.swatch {
  display: inline-block;
  inline-size: 0.8em;
  block-size: 0.8em;
  border-radius: 0.16em;
  margin-inline: 0.4em;
  /* line the swatch up with the text instead of letting it sit on the baseline */
  vertical-align: -0.04em;
  /* helps separate colors from similarly-colored or contrast-lacking backgrounds */
  box-shadow:
    inset 0 0 0 1px rgba(0, 0, 0, 0.25),
    0 0 0 1px rgba(255, 255, 255, 0.18);
}
